import React, { FC } from 'react'
import { Grid } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { RightPanel } from './RightPanel'
import { LeftPanel } from './LeftPanel'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
  main: {
    width: '100%',
    background: 'linear-gradient(to right, #fff 50%, #584de2 50%)',
    minHeight: 'calc(100vh - 248px)',
  },
  container: {
    maxWidth: 1184,
    margin: '0 auto',
  },
}))

export const Login: FC = () => {
  const classes = useStyles()
  return (
    <section className={classes.main}>
      <Grid container direction="row" justifyContent="center" alignItems="flex-start" className={classes.container}>
        <Grid item xs={6}>
          <LeftPanel />
        </Grid>

        <Grid item xs={6}>
          <RightPanel />
        </Grid>
      </Grid>
    </section>
  )
}
